/*@flow*/
import getTypeName from './getTypeName';
import type { PropsT } from './types';

function getDefaultInterfaceName(props: PropsT): string {
  return (
    '{' +
    Object.keys(props)
      .map(k => k + ': ' + getTypeName(props[k]))
      .join(', ') +
    '}'
  );
}

export default getDefaultInterfaceName;
